import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(0, 3, 4),
      background: COLORS.neutral.white,
    },
    skeleton: {
      borderRadius: theme.shape.borderRadiusMedium,
    },
    container: {
      display: 'flex',
      background: COLORS.gray.gray90,
      columnGap: theme.spacing(1),
      alignItems: 'center',
      borderRadius: theme.shape.borderRadiusMedium,
      border: theme.shape.borderGray70,
      padding: theme.spacing(1.75, 2),
      height: 72,
      color: COLORS.gray.black,
      '&$shouldUpgrade': {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
      },
      '&$highlighted': {
        borderColor: COLORS.primary.default,
      },
      '&$empty': {
        height: 'unset',
      },
      '&$isInfinity': {
        '& $subtitle': {
          fontSize: theme.typography.pxToRem(13),
          lineHeight: theme.typography.pxToRem(16),
        },
        '& $accountName': {
          fontSize: theme.typography.pxToRem(13),
          lineHeight: theme.typography.pxToRem(16),
        },
      },
    },
    connected: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: COLORS.primary.silver,
      },
    },
    highlighted: {},
    shouldUpgrade: {},
    empty: {},
    isInfinity: {},
    subtitle: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(22),
      display: 'inline',
      width: 375,
      columnGap: theme.spacing(0.25),
      '& span': {
        verticalAlign: 'middle',
      },
    },
    subtitleEmpty: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(18),
      width: 385,
      '& b': {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(22),
      fontWeight: theme.typography.fontWeightMedium,
      color: COLORS.gray.black,
      paddingRight: theme.spacing(1),
      borderRight: theme.shape.borderGray70,
      minWidth: 'max-content',
    },
    connectButton: {
      ...theme.typography.medium14,
      padding: theme.spacing(1, 1.5),
      height: 32,
      marginLeft: 'auto',
      minWidth: 'max-content',
    },
    loader: {
      marginLeft: 'auto',
    },
    accountName: {
      display: 'inline-block',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(22),
      maxWidth: '100%',
    },
    settingsButton: {
      color: COLORS.gray.gray40,
      padding: theme.spacing(0.75, 0.5),
      marginLeft: 'auto',
      '&:hover, &:active': {
        backgroundColor: 'unset',
      },
    },
    upgradeWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(1.25, 2),
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12,
      border: theme.shape.borderGray70,
      borderTop: 0,
    },
    upgradeText: {
      width: 379,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(18),
      color: COLORS.gray.gray30,
    },
    upgradeButton: {
      ...theme.typography.medium14,
      padding: theme.spacing(1, 1.5),
      height: 32,
      marginRight: theme.spacing(1.5),
      marginLeft: theme.spacing(2),
      backgroundColor: COLORS.success.default,
      color: COLORS.neutral.white,
      minWidth: 'max-content',
      '&:hover': {
        backgroundColor: COLORS.success.default,
      },
    },
    closeButton: {
      color: COLORS.gray.gray40,
      padding: 0,
      '&:hover': {
        background: 'unset',
      },
      '& svg': {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    iconSearch: {
      fontSize: theme.typography.pxToRem(20),
      color: COLORS.gray.gray40,
      marginRight: theme.spacing(1),
    },
  }),
  { name: 'Benchmark' }
);
